<style lang="scss" scoped>
.contianer {
	width: 100%;
	height: 1190px;
	box-sizing: border-box;
	text-align: center;
	padding-top: 106px;
}
.role-content {
	position: relative;
	width: 1530px;
	height: 1068px;
	margin: 0 auto;
	.role-animate1 {
		position: absolute;
		top: 0;
    	right: 85px;
		animation:animation1 40s linear infinite;
	}
	.role-bg {
		position: absolute;
		top: 79px;
    	right: 165px;
	}
	.role-item {
		position: absolute;
		z-index: 0;
		top: -65px;
    	right: 130px;
	}
	.role-introduce-voice {
		position: relative;
		z-index: 10;
		float: left;
    	margin-top: 365px;
		width: 124px;
		height: 520px;
		background: url('../../assets/pc/role-introduce-voice.png');
	}
	.role-introduce {
		position: relative;
		z-index: 10;
		float: left;
		margin-top: 332px;
		margin-left: 195px;
		margin-right: 10px;
		width: 216px;
		height: 546px;
		background: url('../../assets/pc/role-introduce.png');
		writing-mode: tb-rl;
		letter-spacing: 2px;
		text-align: start;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		padding: 70px 54px 30px 5px;
		line-height: 32px;
		color: #5c4320;
		font-size: 20px;
		overflow: hidden;
	}
	.left {
		position: absolute;
		left: 140px;
    	top: 495px;
		cursor: pointer;
	}
	.right {
		position: absolute;
		right: 160px;
    	top: 495px;
		cursor: pointer;
	}
}
@keyframes animation1 {
	0%{ transform: rotate(0deg); }
	100%{ transform: rotate(360deg); }
}
.japan-voice {
	float: left;
	width: 55px;
	margin-left: 9px;
}
.china-voice {
	float: right;
	width: 60px;
	.word {
		box-sizing: border-box;
		padding-right: 2px;
	}
}
.china-voice,
.japan-voice {
	height: 405px;
	margin-top: 45px;
	.voicer {
		height: 150px;
		line-height: 54px;
		font-size: 18px;
		writing-mode: tb-rl;
    letter-spacing: 2px;
		color: #5c4320;
	}
	.voice-btn {
		cursor: pointer;
		margin-bottom: 8px;
	}
	.word {
		width: 100%;
    height: 220px;
    font-size: 14px;
    writing-mode: tb-rl;
    letter-spacing: 2px;
		color: #6a5521;
		text-align: start;
		display: flex;
    align-content: center;
    align-items: center;
	}
}
.slide-fade-enter-active {
	transition: all 2s ease;
}
.slide-fade-enter {
  transform: translateY(-20px);
  opacity: 0;
}
</style>

<template>
<div class="p-role pc-common-bg">
	<div class="contianer">
		<div class="role-content">
			<img class="role-animate1" src="../../assets/pc/role-animate1.png" alt="">
			<img class="role-bg" src="../../assets/pc/role-bg.png" alt="">
			<!-- 人物图 -->
			<template v-for="(item, index) in roleList">
				<transition name="slide-fade" :key="item.figureId">
					<img 
						v-show="roleChooseIndex == index" 
						@mousemove="clearInterval" 
						@mouseout="interval" 
						:src="item.figureImagePath" 
						:alt="item.figureImageName" 
						class="role-item"
					>
				</transition>
			</template>
			<!-- 简介 -->
			<div class="role-introduce">{{roleChoose.figureCharacter}}</div>
			<div @mousemove="clearInterval" @mouseout="interval" class="role-introduce-voice">
				<!-- 日 -->
				<div class="japan-voice">
					<div class="voicer">日·{{roleChoose.figureVoiceNameRi}}</div>
					<img class="voice-btn" @click="playJapanVoice" src="../../assets/pc/voice-btn.png" alt="">
					<div class="word">{{roleChoose.figureVoiceTextRi}}</div>
				</div>
				<audio :src="roleChoose.figureVoiceFilePathRi" id="japan_audio"></audio>
				<!-- 中 -->
				<div class="china-voice">
					<div class="voicer">中·{{roleChoose.figureVoiceNameZhong}}</div>
					<img class="voice-btn" @click="playChinaVoice" src="../../assets/pc/voice-btn.png" alt="">
					<div class="word">{{roleChoose.figureVoiceTextZhong}}</div>
				</div>
				<audio :src="roleChoose.figureVoiceFilePathZhong" id="china_audio"></audio>
			</div>
			<img @click="goPreview" @mousemove="clearInterval" @mouseout="interval" class="left" src="../../assets/pc/left.png" alt="">
			<img @click="goNext" @mousemove="clearInterval" @mouseout="interval" class="right" src="../../assets/pc/right.png" alt="">
		</div>
	</div>
	<p-footer></p-footer>
</div>
</template>

<script>
import Footer from '../../components/Footer'
export default {
	name: 'p-role',
	components: {
		'p-footer': Footer
	},
	computed: {
		roleChoose() {
			if(this.roleList.length > 0) {
				return this.roleList[this.roleChooseIndex];
			} else {
				return {
					figureVoiceNameRi: '',
					figureVoiceTextRi: '',
					figureVoiceNameZhong: '',
					figureVoiceTextZhong: '',
					figureCharacter: '',
					figureVoiceFilePathRi: null,
					figureVoiceFilePathZhong: null
				}
			}
		}
	},
	data() {
		return {
			roleChooseIndex: 0,
			roleList: [],
			chinaVoiceRoot: null,
			japanVoiceRoot: null,
			timeInterval: null
		}
	},
	watch: {
		roleChooseIndex() {
			this.chinaVoiceRoot.load();
			this.japanVoiceRoot.load();
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width < 850) {
			this.$router.push({name: 'm-role'});
		} else {
			this.chinaVoiceRoot = document.getElementById('china_audio');
			this.japanVoiceRoot = document.getElementById('japan_audio');
			this.init();
			this.interval();
		}
	},
	methods: {
		init() {
			this.$http.get('/api/website/getFigureInfo?platform=1').then((rsp) => {
				this.roleList = rsp.result.figures;
			});
		},
		interval() {
			this.timeInterval = setInterval(() => {
				if(this.roleList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.roleChooseIndex == this.roleList.length-1) {
						this.roleChooseIndex = 0;
					} else {
						this.roleChooseIndex ++;
					}
				}
			}, 10000);
		},
		clearInterval() {
			clearInterval(this.timeInterval);
		},
		goPreview() {
			if(this.roleChooseIndex == 0) {
				this.roleChooseIndex = this.roleList.length - 1;
			} else {
				this.roleChooseIndex --;
			}
		},
		goNext() {
			if(this.roleChooseIndex + 1 >= this.roleList.length) {
				this.roleChooseIndex = 0;
			} else {
				this.roleChooseIndex ++;
			}
		},
		playJapanVoice() {
			if(this.chinaVoiceRoot.played) {
				this.chinaVoiceRoot.pause();
			}
			if (this.japanVoiceRoot.paused) {
				this.japanVoiceRoot.play();
			} else {
				this.japanVoiceRoot.pause();
			}
		},
		playChinaVoice() {
			if(this.japanVoiceRoot.played) {
				this.japanVoiceRoot.pause();
			}
			if (this.chinaVoiceRoot.paused) {
				this.chinaVoiceRoot.play();
			} else {
				this.chinaVoiceRoot.pause();
			}
		}
	},
	beforeDestroy() {
		this.clearInterval();
	}
}
</script>